import classnames from "classnames";
import React from "react";

import { useBreakpoint } from "@utils/breakpoints/breakpoints.provider";

import "./energyLabel.scss";
import { type AemEnergyLabelRenditions, getImageRendition } from "./utils";

type Props = {
    energyLabel: string;
    energyLabelLarge?: AemEnergyLabelRenditions;
    energyLabelSize: string;
    oneByTwo: boolean;
    energyLabelAltText: string;
};

const EnergyLabelComponent = ({
    energyLabel,
    energyLabelLarge,
    energyLabelSize,
    oneByTwo,
    energyLabelAltText,
}: Props) => {
    const { breakpoints } = useBreakpoint();

    let image;
    const isLarge = energyLabelSize === "lg" && energyLabelLarge;

    if (isLarge) {
        image = getImageRendition(energyLabelLarge, oneByTwo, breakpoints);
    } else {
        image = energyLabel;
    }

    return (
        <img
            className={classnames(
                energyLabelSize === "lg"
                    ? "energyLabel-large"
                    : "energyLabel-small",
                { ["energyLabel-noLargeLabel"]: !energyLabelLarge },
            )}
            src={image}
            alt={isLarge ? energyLabelLarge.altText : energyLabelAltText || ""}
            onClick={() => {
                if (energyLabelLarge) {
                    window.location.hash = "energylabel";
                }
            }}
        />
    );
};

export default EnergyLabelComponent;
